"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.zodRequiredUnknown = void 0;
const zod_1 = require("zod");
const zodRequiredUnknown = () => zod_1.z.custom((v) => v !== undefined && v !== null, {
    message: 'is required and may not be null',
});
exports.zodRequiredUnknown = zodRequiredUnknown;
//# sourceMappingURL=zod-required-unknown.js.map